import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
interface RevealTextProps {
  text: string;
  className?: string;
  delay?: number;
  as?: React.ElementType;
}
export function RevealText({
  text,
  className = '',
  delay = 0,
  as: Component = 'span'
}: RevealTextProps) {
  // Split by words for RTL-friendly animation
  const words = text.split(' ');
  const container = {
    hidden: {
      opacity: 0
    },
    visible: (i = 1) => ({
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: delay * 0.1
      }
    })
  };
  const child = {
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        damping: 24,
        stiffness: 100
      }
    },
    hidden: {
      opacity: 0,
      y: 20
    }
  };
  return <motion.div style={{
    display: 'inline-flex',
    flexWrap: 'wrap',
    gap: '0.25em'
  }} variants={container} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-10%'
  }} className={className} data-id="element-150">
      {words.map((word, index) => <motion.span variants={child} key={index} style={{
      display: 'inline-block'
    }} data-id="element-151">
          {word}
        </motion.span>)}
    </motion.div>;
}